import React from "react";
import ProductView from "../src/components/ProductView/ProductView";

export default function App() {
  return (
    <div>
      <h1>Products</h1>
      <ProductView />
    </div>
  );
}
